import React, { useState } from 'react';
import { MessageCompositionStudio } from '../useMessageCompositionStudio';
import TemplateTabs from '../content/TemplateTabs';
import LinkTemplateDialog from '../content/LinkTemplateDialog';
import EmailContentEditor from '../content/email/EmailContentEditor';
import SlackContentEditor from '../content/slack/SlackContentEditor';
import WhatsAppContentEditor from '../content/whatsapp/WhatsAppContentEditor';

const ContentSection: React.FC<{ studio: MessageCompositionStudio }> = ({ studio }) => {
    const { meta, bodies, activeBody, readOnly, linkableTemplates } = studio;
    const activeTemplate = activeBody;
    const [linking, setLinking] = useState(false);
    if (!meta) return null;

    const config = meta.channelConfig;

    const editor = () => {
        if (!activeTemplate) {
            return (
                <div className="rounded-xl border-2 border-dashed border-gray-300 dark:border-slate-600 p-10 text-center">
                    <p className="text-sm text-gray-600 dark:text-gray-300">Esta composição ainda não tem modelo.</p>
                    {!readOnly && (
                        <button type="button" onClick={studio.draftNewTemplate} className="mt-3 text-sm text-teal-700 dark:text-teal-300 hover:underline">
                            Redigir o primeiro modelo
                        </button>
                    )}
                </div>
            );
        }
        if (config.kind === 'EMAIL') {
            return (
                <EmailContentEditor
                    key={activeTemplate.id}
                    template={activeTemplate}
                    disabled={readOnly}
                    onTemplateChange={(patch) => studio.updateTemplate(activeTemplate.id, patch)}
                />
            );
        }
        if (config.kind === 'INTERNAL_MESSAGE') {
            return (
                <SlackContentEditor
                    key={activeTemplate.id}
                    template={activeTemplate}
                    disabled={readOnly}
                    onChange={(content) => studio.updateTemplate(activeTemplate.id, { content })}
                />
            );
        }
        return (
            <WhatsAppContentEditor
                key={activeTemplate.id}
                template={activeTemplate}
                disabled={readOnly}
                catalog={studio.providerCatalog}
                onChange={(patch) => studio.updateTemplate(activeTemplate.id, patch)}
            />
        );
    };

    return (
        <div>
            <TemplateTabs
                templates={bodies}
                activeId={activeTemplate?.id ?? null}
                disabled={readOnly}
                canLink={linkableTemplates.length > 0}
                onSelect={studio.setActiveTemplateId}
                onRename={(id, name) => studio.updateTemplate(id, { name })}
                onDraftNew={studio.draftNewTemplate}
                onDuplicate={studio.duplicateTemplate}
                onLinkExisting={() => setLinking(true)}
                onRemove={studio.removeTemplate}
            />
            {editor()}
            <LinkTemplateDialog
                show={linking}
                templates={linkableTemplates}
                onClose={() => setLinking(false)}
                onLink={studio.linkExistingTemplate}
            />
        </div>
    );
};

export default ContentSection;
